export default __webpack_public_path__ + "static/pintrest-a9bce1561811440f97e28c788d42f6f9.png";